import { OktaAuth } from '@okta/okta-auth-js';
import { config } from '../config/env';

// Get configuration from runtime or build-time config
const OKTA_ISSUER = config.oktaIssuer;
const OKTA_CLIENT_ID = config.oktaClientId;
const REDIRECT_URI = `${window.location.origin}/callback`;
const POST_LOGOUT_REDIRECT_URI = `${window.location.origin}/login`;

if (!OKTA_ISSUER || !OKTA_CLIENT_ID) {
  console.error('Missing Okta configuration. Set VITE_OKTA_ISSUER and VITE_OKTA_CLIENT_ID for local development.');
}

// Create Okta Auth instance for SPA
export const oktaAuth = new OktaAuth({
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENT_ID,
  redirectUri: REDIRECT_URI,
  postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
  scopes: [
    'openid',
    'profile',
    'email',
    'okta.aiAgents.read',
    'okta.aiAgents.manage',
    'okta.apps.read',
    'okta.apps.manage',
    'okta.users.read',
    'okta.authorizationServers.read',
  ], // OIDC scopes + Management API scopes for admin operations
  pkce: true,
  tokenManager: {
    autoRenew: true,
    storage: 'sessionStorage' // More secure than localStorage
  }
});
